import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  image: {
    display: 'block',
    height: 34,
    width: 'auto',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      alt="Cedarwell"
      className={classes.image}
      src="/assets/brand/backstage/sidebar-full.svg"
    />
  );
};
